// import logo from "./logo.svg";
import * as React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import "@fontsource/hind-siliguri";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Gastrick from "./Pages/GasTrick/Gastrick/Gastrick";
import PhysicsOff from "./Pages/PhysicsOff/Physicsoff/PhysicsOff";
import GasTrickAdmin from "./Pages/Admin/GasTrickAdmin/GasTrickAdmin";
import PhysicsOffAdmin from "./Pages/Admin/PhysicsOffAdmin/PhysicsOffAdmin";
import ApolloShort from "./Pages/ApolloShort/ApolloShort/ApolloShort";
import ApolloShortAdmin from "./Pages/Admin/ApolloShortAdmin/ApolloShortAdmin";
import PhoenixShort from "./Pages/PhoenixShort/PhoenixShort/PhoenixShort";
import PhoenixShortAdmin from "./Pages/Admin/PhoenixShortAdmin/PhoenixShortAdmin";
import PhysicsAdmission from "./Pages/PhysicsAdmissionBatch/PhysicsAdmission/PhysicsAdmission";
import FinalPhase from "./Pages/POSFinalPhase/FinalPhase/FinalPhase";
import Home from "./Pages/Home/Home/Home";
import InceptionFi from "./Pages/InceptionFi/InceptionFi/InceptionFi";
import BatchConclution from './Pages/BatchConclution/BatchConclution/BatchConclution';
function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const theme = React.useMemo(
    () =>
      createTheme({
        typography: {
          fontFamily: "Hind Siliguri",
        },
        palette: {
          mode: prefersDarkMode ? "dark" : "dark",
          background: {
            default: "#0f0826",
            paper: "#2568FB",
          },
        },
      }),
    [prefersDarkMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <>
        <div className="App">
          <BrowserRouter>
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>

              <Route exact path="/BatchConclution22">
                <BatchConclution />
              </Route>
              <Route exact path="/InceptionFi">
                <InceptionFi />
              </Route>
              
              <Route exact path="/Physicsadmissionbatch">
                <PhysicsAdmission />
              </Route>

              <Route exact path="/FinalPhasePOS">
                <FinalPhase />
              </Route>
              <Route exact path="/GasTrick">
                <Gastrick></Gastrick>
              </Route>
              <Route exact path="/WhyGasTrickIsAdmin">
                <GasTrickAdmin></GasTrickAdmin>
              </Route>
              <Route exact path="/PhysicsOff">
                <PhysicsOff></PhysicsOff>
              </Route>
              <Route exact path="/WhyPhysicsOffIsAdmin">
                <PhysicsOffAdmin></PhysicsOffAdmin>
              </Route>

              <Route exact path="/ApolloShort">
                <ApolloShort></ApolloShort>
              </Route>
              <Route exact path="/WhyApolloShortIsAdmin">
                <ApolloShortAdmin></ApolloShortAdmin>
              </Route>
              <Route exact path="/PhoenixShort">
                <PhoenixShort></PhoenixShort>
              </Route>
              <Route exact path="/WhyPhoenixShortIsAdmin">
                <PhoenixShortAdmin></PhoenixShortAdmin>
              </Route>
            </Switch>
          </BrowserRouter>
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
